import React from 'react';
import './Card.css';

const Card = ({
  children,
  title = null,
  subtitle = null,
  className = '',
  padding = 'md',
  hoverable = false,
  elevation = 'base', // sm, base, md, lg, none
  ...props
}) => {
  const classNames = [
    'card',
    `card-padding-${padding}`,
    `card-elevation-${elevation}`,
    hoverable && 'card-hoverable',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classNames} {...props}>
      {(title || subtitle) && (
        <div className="card-header">
          <div className="card-header-content">
            {title && <h3 className="card-title">{title}</h3>}
            {subtitle && <p className="card-subtitle">{subtitle}</p>}
          </div>
        </div>
      )}
      <div className="card-content">{children}</div>
    </div>
  );
};

export default Card;

